import { axios } from "utils";

import { ADMIN_ARTICLES_URL as endpoint } from "consts";

export const getAllArticles = async (data) => axios.get(`${endpoint}`, { data });

export const addArticle = async (data) => axios.post(`${endpoint}`, { data });

export const getArticle = async (data) => axios.get(`${endpoint}/${data.id}`, { data });

export const updateArticle = async (data) => axios.put(`${endpoint}/${data.link}`, { data });

export const getArticleAudio = async (data) => axios.get(`${endpoint}/${data.id}/audio`, { data });
